import React from 'react';
import {Box, Typography} from '@mui/material';
import {node, object, string} from 'prop-types';

export const ChipAndLabel = ({color, label, sx = {}}) => (
  <Box display="inline-flex" alignItems="center" sx={sx}>
    <Box
      marginRight={0.5}
      width="1em"
      height="1em"
      display="inline-block"
      sx={{
        backgroundColor: `${color}.light`,
        border: 'solid 2px',
        borderColor: `${color}.main`,
      }}
    />
    <Typography component="span" sx={{fontWeight: 'normal', fontSize: 12}}>
      {label}
    </Typography>
  </Box>
);

ChipAndLabel.propTypes = {
  color: string,
  label: node,
  sx: object,
};
